<template>
  <div class="dashboard-container">
    <div class="app-container">组题列表</div>
  </div>
</template>

<script>
export default {
  name: 'QuestionsRandoms',
  data() {
    return {}
  }
}
</script>

<style scoped>
</style>
